const translations = {
    de: {
        weekDays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag',],
        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',],
    },
    it: {
        weekDays: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato',],
        months: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre',],
    },
    en: {
        weekDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December',],
    },
    fr: {
        weekDays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    },
    nl: {
        weekDays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
        months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
    },
    pl: {
        weekDays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
        months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
    },
};
export function dateFormatter(language) {
    const T = translations[language];
    // format: 'ddd, dd. MMMM yyyy'
    return (date, format) => {
        const obj = parse(date);
        if (obj)
            return print(obj, format);
        return null;
    };
    function parse(date) {
        if (date instanceof Date) {
            return date;
        }
        else if (typeof date === 'string') {
            const time = Date.parse(date);
            return time > 0 ? new Date(time) : null;
        }
    }
    function print(date, format) {
        const pad = (s) => `${s}`.padStart(2, "0");
        const convert = (pattern) => {
            switch (pattern) {
                case 'd': return date.getDate();
                case 'dd': return pad(date.getDate());
                case 'ddd': return T.weekDays[date.getDay()].substring(0, 2);
                case 'dddd': return T.weekDays[date.getDay()];
                case 'M': return date.getMonth() + 1;
                case 'MM': return pad(date.getMonth() + 1);
                case 'MMM': return T.months[date.getMonth()].substring(0, 3);
                case 'MMMM': return T.months[date.getMonth()];
                case 'yy': return date.getFullYear().toString().substring(2);
                case 'yyyy': return date.getFullYear();
            }
        };
        return format.replace(/([dMy]+)([^dMy]*)?/g, (match, p1, p2) => `${convert(p1)}${p2 || ''}`);
    }
}
